var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhase3Chapter1Bkg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "FOND",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1383.939,
    height: 1037.954,
    viewBox: "0 0 1383.939 1037.954",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-chapter1-bkg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "FOND_FIXE",
    "data-name": "FOND FIXE",
    d: "M0,0H1383.939V1037.954H0Z",
    fill: "#9870b6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-chapter1-bkg-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "FOND_FIXE-2",
    "data-name": "FOND FIXE",
    d: "M0,0H1394.051V1169.1H0Z",
    fill: "#3b3b3b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.507,
    y1: -0.001,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc875"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe6c1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.519,
    y1: 0.142,
    x2: 0.543,
    y2: 0.948,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffaf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.127,
    stopColor: "#fff6e8",
    stopOpacity: 0.808
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#fff1dc",
    stopOpacity: 0.565
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    stopColor: "#ffedd2",
    stopOpacity: 0.365
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636,
    stopColor: "#ffeacb",
    stopOpacity: 0.208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#ffe7c5",
    stopOpacity: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#ffe6c2",
    stopOpacity: 0.024
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe6c1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.54,
    y1: 0.207,
    x2: 0.387,
    y2: 0.832,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffaf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.127,
    stopColor: "#fff6e8",
    stopOpacity: 0.808
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#fff1dc",
    stopOpacity: 0.565
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    stopColor: "#ffedd2",
    stopOpacity: 0.365
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636,
    stopColor: "#ffeacb",
    stopOpacity: 0.208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#ffe7c5",
    stopOpacity: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#ffe6c2",
    stopOpacity: 0.024
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    stopColor: "#ffe6c1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.5,
    y1: 0.022,
    x2: 0.5,
    y2: 0.705,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dce7d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436,
    stopColor: "#b8dcd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbe298"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffeaa4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2cc76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.424,
    y1: 0.676,
    x2: 0.697,
    y2: 0.003,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffce81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd490"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.5,
    x2: 0.5,
    y2: 0.84,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcdc96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbb74a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbb74a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5d382"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.5,
    y1: 0.089,
    x2: 0.491,
    y2: 2.079,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcb647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fffdfa"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "FOND_FIXE-3",
    "data-name": "FOND FIXE",
    d: "M0,0H1383.939V1037.954H0Z",
    transform: "translate(0 0)",
    fill: "#387682"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_58",
    "data-name": "Mask Group 58",
    clipPath: "url(#clip-path-chapter1-bkg)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6211",
    "data-name": "Group 6211",
    transform: "translate(-364.844 -186.687)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FOND-2",
    "data-name": "FOND",
    transform: "translate(364.844 83)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_27",
    "data-name": "Mask Group 27",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-chapter1-bkg-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1384",
    "data-name": "Rectangle 1384",
    width: 1344.007,
    height: 1006.684,
    transform: "translate(80.089 22.887)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8609",
    "data-name": "Path 8609",
    d: "M1253.984,64.629V264.178q-33.725.695-67.967,1.444c-141.841,3.025-288.864,5.942-427.507,2.4-140.084-3.584-283.322-4.592-410.77-39.983,19.9-15.576,61.324-18.861,87.166-6.923,4.506-8.2,26.064-12.115,36.9-6.473,7.074-17.961,33.951-34.6,63.666-38.839S598.418,178.27,618,192.442c13.628-8.122,37.893-10.357,54.813-4.96,12.391-12.551,38.119-17.879,56.838-8.613,6.535-19.828,31.295-37.217,63.105-43.418s68.893-1.213,93.357,12.565c10.41-4.17,28.837-2.317,38.366,2.548,23-20.046,78.155-27.719,113.638-16.108,5.024-16.053,30.752-30.076,55.488-36.6,24.759-6.541,54.768-5.179,77.634,3.5,5.722-13.028,28.95-23.017,48.144-29.858A127.934,127.934,0,0,1,1253.984,64.629Z",
    transform: "translate(169.424 624.919)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8610",
    "data-name": "Path 8610",
    d: "M497.6,262.724C335.026,301.378,167.186,337.44,0,330.253V69.009c22.8,7.377,42.514,23.437,51.886,44.3,17.367-5.543,36.091,2.761,49.135,14.838,15.883-10.981,39.583-12.435,58.911-8.662,19.309,3.794,36.679,15.576,46.5,31.573,10.025-2.8,25.75,5.8,28.229,15.3,18.2-16.25,46.858-21.73,71.371-16.4s45.621,22.763,54.317,44.872a27.676,27.676,0,0,1,25.548,2.592,23.783,23.783,0,0,1,10.341,22.025c17.705-7.672,44.99-3.1,62.9,4.11C477.048,230.793,491.4,245.4,497.6,262.724Z",
    transform: "translate(81.015 527.583)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5362",
    "data-name": "Group 5362",
    transform: "translate(-118.077 -34.985)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "FOND-3",
    "data-name": "FOND",
    d: "M1653.458,1239.823H0V0H1653.458Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "FOND_DUNE",
    "data-name": "FOND DUNE",
    transform: "translate(96.15 619.896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5336",
    "data-name": "Group 5336",
    transform: "translate(560.773 8.965)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8993",
    "data-name": "Path 8993",
    d: "M1201.479,345.647v137.34S151.086,426.873,298.368,405.263C584.225,363.307,753.224,296.96,890.53,295.83c27.036-.235,52.844,2.075,78.082,7.589C1157.245,344.665,1201.479,345.647,1201.479,345.647Z",
    transform: "translate(-284.211 -295.813)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8994",
    "data-name": "Path 8994",
    d: "M903.049,345.647v31.286c-30.975,2.235-34.427,2.806-94.653-.236-170.855-8.62-209.139-65.863-216.3-80.867,27.036-.235,52.844,2.075,78.082,7.589C858.815,344.665,903.049,345.647,903.049,345.647Z",
    transform: "translate(14.22 -295.813)",
    fill: "url(#linear-gradient-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5338",
    "data-name": "Group 5338",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5337",
    "data-name": "Group 5337"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8995",
    "data-name": "Path 8995",
    d: "M1478.042,416.151V561.185H0V331.564s65.69-25.728,111.233-40.444c3.181-1.028,7.4-2.822,11.471-2.66,80.841,3.217,272.518,110.46,730.91,142.08,204.37,14.091,460.538,7.982,460.538,7.982Z",
    transform: "translate(0 -288.45)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8996",
    "data-name": "Path 8996",
    d: "M1254.674,440.585C1161.139,452.98,681.66,509.34,364.6,450.969,41.974,391.567,58.046,305,63.108,290.7c80.855,3.217,272.693,108.11,731.165,139.73C998.679,444.522,1146.955,442.491,1254.674,440.585Z",
    transform: "translate(59.381 -290.686)",
    fill: "url(#linear-gradient-8)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "FOND-4",
    "data-name": "FOND",
    d: "M1653.458,348.275H0V0H1653.458Z",
    transform: "translate(0 891.548)",
    fill: "url(#linear-gradient-9)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhase3Chapter1Bkg);
export default __webpack_public_path__ + "static/media/phase3-chapter1-bkg.d93aa4d8.svg";
export { ForwardRef as ReactComponent };